<template>
    <IPProgressBar :stages="stagesSteps" v-model="currentStage"/>
    <form class="section section-aside individual-packing" @submit.prevent>
        <template v-for="(stage, index) in getFormStages" :key="stage.code">
            <IPStage v-if="currentStage === stage.code" @next="setNextStage(index)" @prev="setPrevStage(index)" form-type="full" :stage-data="stage"/>
        </template>
        <IPFinalStage v-if="currentStage === 'finalStage'" @edit-stage="setStage" @submit-form="submitForm" @prev="setPrevStage(getFormStages.length)"/>
    </form>
</template>

<script>
import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import IPProgressBar from "@/components/individual-packing/utils/IPProgressBar.vue";
import IPStage from '@/components/individual-packing/IPStage.vue';
import IPFinalStage from "@/components/individual-packing/IPFinalStage.vue";

export default {
    name: "IPForm",
    mixins: [useIndividualPacking],
    components: {
        IPFinalStage,
        IPProgressBar,
        IPStage
    },
    data() {
        return {
            currentStage: ''
        }
    },
    created() {
        this.setInitialData();
    },
    computed: {
        stagesSteps() {
            return this.getFormStages.map((stage) => {
                const {name, code, id} = stage;
                return {
                    name,
                    code,
                    id,
                    disabled: true
                }
            })
        }
    },
    methods: {
        setInitialData() {
            if (this.getFormStages.length) {
                this.currentStage = this.getFormStages[0].code;
            } else {
                this.requestFormStages().then((stages) => {
                    if (stages.length) {
                        this.currentStage = stages[0].code;
                    }
                });
            }
        },
        setStage(stageCode) {
            this.currentStage = stageCode;
        },
        setNextStage(stageIndex) {
            const nextStage = this.getFormStages[stageIndex + 1];
            if (nextStage) {
                this.currentStage = nextStage.code;
            } else {
                this.currentStage = 'finalStage';
            }
        },
        setPrevStage(stageIndex) {
            const prevStage = this.getFormStages[stageIndex - 1];
            if (prevStage) {
                this.currentStage = prevStage.code;
            } else {
                this.setCurrentFormView('');
            }
        },
        submitForm() {
            this.sendIndividualPacking().then(() => {
                if (window.FancyBox) {
                    window.FancyBox.show([{src: '#popup-constructor-success'}], {
                        Toolbar: false,
                        dragToClose: false,
                        Thumbs: false,
                        mainClass: "fullscreen",
                        autoFocus: true,
                    })
                }
                this.setCurrentFormView('');
            }).catch(() => {
                if (window.FancyBox) {
                    window.FancyBox.show([{src: '#popup-constructor-error'}], {
                        Toolbar: false,
                        dragToClose: false,
                        Thumbs: false,
                        mainClass: "fullscreen",
                        autoFocus: true,
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>